import Network from "../utils/Network";
import { WheelDetail, WheelEvent, WheelSpinRequest, WheelSpinResult } from "../types/wheel-of-luck";
import { isWheelDetail, wheelErrorCode } from "../utils/wheel-of-luck";

export class WheelApiError extends Error {
  code: string;
  uncertain: boolean;
  constructor(message: string, public status?: number) {
    super(message);
    this.code = wheelErrorCode(message);
    // A server or transport failure cannot establish whether payment happened.
    this.uncertain = !status || status >= 500 || status === 408;
  }
}

async function request<T>(url: string, body?: WheelSpinRequest): Promise<T> {
  const response = await new Network().CallApi<T>({
    url: `/WheelOfLuck/${url}`,
    method: body ? "post" : "get",
    timeout: 20000,
    ...(body ? { body } : {}),
  });
  if (!response.ok) throw new WheelApiError(response.message || "Unable to load the wheel.", response.status);
  return response.data;
}

function detail(data: WheelDetail): WheelDetail {
  if (!isWheelDetail(data)) throw new WheelApiError("Invalid wheel response. Please reload.");
  return data;
}

export const wheelApi = {
  async list(): Promise<WheelEvent[]> {
    const data = await request<WheelEvent[]>("list");
    if (!Array.isArray(data)) throw new WheelApiError("Invalid events response. Please reload.");
    return data;
  },
  async open(id: number): Promise<WheelDetail> {
    return detail(await request<WheelDetail>(String(id)));
  },
  async historical(keyId: number): Promise<WheelDetail> {
    return detail(await request<WheelDetail>(`historical?keyId=${keyId}`));
  },
  async spin(body: WheelSpinRequest): Promise<WheelSpinResult> {
    const data = await request<WheelSpinResult>("spin", body);
    if (!data || !Number.isInteger(data.winningSlotIndex) || data.winningSlotIndex < 0 ||
      data.winningSlotIndex > 7 || !data.grantedReward ||
      data.grantedReward.slotIndex !== data.winningSlotIndex ||
      !isWheelDetail(data.wheel) || data.wheel.playerWheelOfLuckId !== body.playerWheelOfLuckId) {
      throw new WheelApiError("The spin result could not be confirmed. Retry to recover the same spin.");
    }
    return data;
  },
};
